import document from './document'

export default {
    /**
    guidanceProposal: {
        icon: 'file-sync',
        text: 'Bimbingan Proposal',
        route: 'admin.project.guidance.proposal',
        role: {
            project: [ 'attendant' ],
        }
    },
     */
    guidanceProposalSummary: {
        icon: 'file-done',
        text: 'Bimbingan Proposal',
        route: 'admin.project.guidance.proposal.summary',
        role: {
            project: [ 'advisor' ],
        }
    },
    guidanceProposalSummaryMentor: {
        icon: 'file-done',
        text: 'Validasi Proposal',
        route: 'admin.project.guidance.proposal.summary',
        role: {
            project: [ 'mentor' ],
        }
    },
    guidanceProposalScoring: {
        icon: 'file-sync',
        text: 'Penilaian Proposal',
        route: 'admin.project.scoring.proposal',
        role: {
            project: [ 'mentor', 'evaluator', 'advisor' ],
        }
    },
    document: {
        icon: 'file',
        text: 'Dokumentasi Project',
        route: 'general.project.document',
        role: {
            project: [ 'attendant' ],
        },
        children: Object.assign({}, document),
    },
    /**
    guidanceProject: {
        icon: 'file-sync',
        text: 'Evaluasi Project',
        route: 'admin.project.guidance.project_evaluation',
        role: {
            project: [ 'attendant' ],
        }
    },
     */
    guidanceProjectSummary: {
        icon: 'file-sync',
        text: 'Bimbingan Evaluasi Project',
        route: 'admin.project.guidance.project_evaluation.summary',
        role: {
            project: [ 'advisor' ],
        }
    },
    guidanceProjectSummaryMentor: {
        icon: 'file-sync',
        text: 'Validasi Evaluasi Project',
        route: 'admin.project.guidance.project_evaluation.summary',
        role: {
            project: [ 'mentor' ],
        }
    },
    guidanceEvaluationScoring: {
        icon: 'carry-out',
        text: 'Penilaian Evaluasi',
        route: 'admin.project.scoring.project_evaluation',
        role: {
            project: [ 'mentor', 'evaluator', 'advisor' ],
        }
    },
    recap: {
        icon: 'control',
        text: 'Performance Mentor',
        route: 'admin.project.mentoring.recap',
        role: {
            project: [ 'mentor' ],
        },
    },
    // notulenProject: {
    //     icon: 'file-text',
    //     text: 'Notulen',
    //     route: 'admin.project.notulen',
    //     role: {
    //         project: [ 'attendant' ],
    //     }
    // },
    /*
    notulenProject: {
        icon: 'file-sync',
        text: 'Notulen',
        route: 'notulen',
        role: {
            project: [ 'attendant' ],
        },
        children: {
            notulenProposal: {
                icon: null,
                text: 'Proposal',
                route: 'admin.project.proposal.notulen',
                role: {
                    project: [ 'attendant' ],
                },
            },
            notulenEvaluasi: {
                icon: null,
                text: 'Evaluasi Project',
                route: 'admin.project.project_evaluation.notulen',
                role: {
                    project: [ 'attendant' ],
                },
            },
        }
    },
    scoreProject: {
        icon: 'file-protect',
        text: 'Nilai Project',
        route: 'admin.project.attendant.score',
        role: {
            project: [ 'attendant' ],
        }
    }
    */
}
